module.exports = __webpack_public_path__ + "img/mm-logo-white@3x.66b16d9c.png";